import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(00, 00, 00, 0.5);
  z-index: 21;
  top: 0;
  left: 0;
  & .container-div {
    width: 500px;
  }
`;
